import React, { useState } from "react";
import { CardBody, Input } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import styles from "../../styles.scss";
import TooltipColorPicker from "../../common/tooltipColorPicker";
import SectionLabel from "../../common/sectionLabel";
import { LeftSidebarVariablesProp } from "../../common/types/variables";

const NewsfeedBodySection = ({ variables }: LeftSidebarVariablesProp) => {
  const [highlightedTextColor, setHighlightedTextColor] = variables[
    "highlightedTextColor"
  ];
  const [giveButtonLabel, setGiveButtonLabel] = variables["giveButtonLabel"];
  const [giveButtonColor, setGiveButtonColor] = variables["giveButtonColor"];

  return (
    <CardBody>
      {/*       <div className={styles.section}>
        <SectionLabel
          label="Highlighted text"
          tooltip="Personalize the color of the highlighted text"
        />
        <TooltipColorPicker
          value={highlightedTextColor}
          setValue={setHighlightedTextColor}
        />
      </div> 
      Currently unavailable for customization, but ready to implement
      */}
      <div className={styles.section}>
        <SectionLabel
          label="Give Button label"
          tooltip="Change the label inside the 'Give' button"
        />
        <Input
          type="text"
          value={giveButtonLabel}
          onChange={e => setGiveButtonLabel(e.target.value)}
          className={styles.input}
        />
        {/*         <SectionLabel
          label="Give Button color"
          tooltip="Personalize the color of the 'Give' button"
        />
        <TooltipColorPicker
          value={giveButtonColor}
          setValue={setGiveButtonColor}
        /> 
          Currently unavailable for customization, but ready to implement
        */}
      </div>
    </CardBody>
  );
};

export default withStyles(styles)(NewsfeedBodySection);
